// Device Model Select component for Alpine.js
// Pass initialId from forms other than devices/new — the fallback lookup is that form's field name.
document.addEventListener('alpine:init', () => {
  Alpine.data('deviceModelSelect', ({ initialId } = {}) => ({
    open: false,
    search: '',
    selectedModel: '',
    selectedId: initialId || document.querySelector('input[name="device[device_model_id]"]')?.value || '',
    models: [],

    init() {
      // Get all device models from the data attribute
      const modelsElement = document.getElementById('device-models-data');
      if (modelsElement) {
        this.models = JSON.parse(modelsElement.textContent);
      }

      // re-render after a validation error: hidden field has the id, label needs the name
      if (this.selectedId) {
        this.selectedModel = this.selectedRecord()?.name || '';
      }

      this.$watch('open', open => open && this.$nextTick(() => this.$refs.search?.focus()));
    },

    selectedRecord() {
      return this.models.find(model => model.id == this.selectedId);
    },

    filteredModels() {
      if (!this.search.trim()) return this.models;

      return matchDeviceModels(this.models, this.search);
    },

    selectFirst() {
      const [first] = this.filteredModels();
      if (first) this.selectModel(first);
    },

    selectModel(model) {
      this.selectedModel = model.name;
      this.selectedId = model.id;
      this.open = false;
      this.search = '';
    }
  }));
});
